import { Box, TextField, Typography, useTheme } from "@mui/material";
import EditIconfrom from "../../../../media/images/icons/edit-icon";
import React from "react";
import useTimer from "../../../../hooks/useTimer";

interface Props {
  mobileNumber?: string;
  name?: string;
  value?: string;
  sendOtpState?: (state: boolean) => void;
  error?: boolean;
  errorMessage?: string | boolean | undefined;
  // handleChange?: (value: string) => void;
  handleChange?:
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
}

export default function OtpInput({
  name,
  value,
  mobileNumber,
  sendOtpState,
  error,
  errorMessage,
  handleChange,
}: Props) {
  const theme = useTheme();

  const [timer, isFinished] = useTimer({
    start: 200,
  });

  if (sendOtpState) {
    sendOtpState(isFinished);
  }

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography
        sx={{
          color: "success.main",
          fontWeight: "600",
          fontSize: "13px",
        }}
      >
        کد اعتبارسنجی به شماره تلفن {mobileNumber} ارسال شد.
      </Typography>
      <Box
        sx={{
          display: "flex",
          paddingX: "8px",
          paddingY: "4px",
          mt: 2,
          justifyContent: "space-between",
          alignItems: "center",
          borderWidth: "2px",
          borderColor: error ? "error.main" : "textColor.light",
          borderRadius: "12px",
          borderStyle: "solid",
        }}
      >
        <TextField
          name={name}
          value={value}
          placeholder="----"
          onChange={handleChange}
          // onChange={(e) => handleChange && handleChange(e.target.value)}
          style={{
            textAlign: "center",
          }}
          sx={{
            "& fieldset": { border: "none" },
          }}
          InputProps={{
            disableUnderline: true,
            dir: "ltr",
          }}
          inputProps={{
            style: {
              textAlign: "center",
              height: "15px",
              fontSize: 18,
            },
          }}
        />
        <Box
          sx={{
            padding: "8px",
            borderRadius: "8px",
            bgcolor: "textColor.light",
            minWidth: "100px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "background.default",
            }}
          >
            {timer}
          </Typography>
        </Box>
      </Box>
      {error && <Typography color="error.main">{errorMessage}</Typography>}
      <Box
        onClick={() => sendOtpState && sendOtpState(true)}
        sx={{
          cursor: "pointer",
          mx: "auto",
          width: "fit-content",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            color: "primary.main",
          }}
        >
          تغییر شماره
        </Typography>
        <EditIconfrom color={theme.palette.primary.main} />
      </Box>
    </Box>
  );
}
